<template>
    <div :class="{ 'accordion__item': true, 'is-active': isActive, 'is-highlighted': highlighted, 'is-parent': parent }">
        <div class="accordion__helper" @click="toggleAccordion">
            <slot name="accordion-head"></slot>
        </div>
        <div v-if="isActive">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        bus: {
            type: Object
        },
        highlighted: {
            type: Boolean,
            default: false
        },
        parent: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isActive: this.active
        }
    },
    methods: {
        toggleAccordion() {
            this.isActive = !this.isActive;
            this.$emit('update:active', this.isActive)
        },
        closeAccordion() {
            this.isActive = false;
        },
        openAccordion() {
            this.isActive = true;
        },
        start(el) {
            el.style.height = `${ el.scrollHeight }px`;
        },
        end(el) {
            el.style.height = '';
        }
    },
    mounted() {
        // Вызов метода закрытия аккордиона в родительском компоненте
        if (this.bus) {
            this.bus.$on('closeAccordion', this.closeAccordion);
            this.bus.$on('openAccordion', this.openAccordion);
        }
    }
};
</script>
